import { ILoaderConstant } from './types';

export const LoadersText: ILoaderConstant = {
  tenant: [
    'Опрашиваем соседей',
    'Катаемся на лифте',
    'Собираем подписи в подъезде',
    'Обновляем табличку у подъезда',
  ],
  worker: [
    'Опрашиваем коллег',
    'Бегаем по кабинетам',
    'Уточняем у секретаря',
    'Пишем в рабочий чат',
  ],
  other: [
    'Спрашиваем у прохожих',
    'Ищем по картотекам',
    'Проводим расследование',
    'Сверяемся с табелем',
  ],
};
